import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { applyDateLocale } from '@/shared/lib/date';

import ar from '../locales/ar.json';
import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import it from '../locales/it.json';
import pt from '../locales/pt.json';
import ru from '../locales/ru.json';
import zh from '../locales/zh.json';

const resources = {
  ar: { translation: ar },
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  ru: { translation: ru },
  zh: { translation: zh }
};

const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('language');
  if (saved) return saved;

  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  const langCode = browserLang.split('-')[0].toLowerCase();

  const supportedLanguages = ['en', 'es', 'it', 'fr', 'ar', 'pt', 'ru', 'zh'];
  return supportedLanguages.includes(langCode) ? langCode : 'en';
};

const savedLanguage = getSavedLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false // React already escapes values
  },
  react: {
    useSuspense: false
  },
  /**
   * Development only. A key assembled at runtime (`sidebar.${code}`) is
   * invisible to any static scan of the sources, so the only place a missing
   * one shows up is here. It warns and moves on — never throws, never ships.
   */
  saveMissing: import.meta.env.DEV,
  missingKeyHandler: import.meta.env.DEV
    ? (languages, _namespace, key) => console.warn(`[i18n] missing key "${key}" for ${languages.join(', ')}`)
    : undefined
});

// Update document direction for RTL languages
export const updateDirection = (lang: string) => {
  const dir = lang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lang;
};

// Initialize direction
updateDirection(savedLanguage);
applyDateLocale(savedLanguage);

export default i18n;
